// extracted by mini-css-extract-plugin
export default {"Button":"style_Button__yz4HM","small":"style_small__REOVX","fullWidth":"style_fullWidth__9e8tp"};